// Shared by the header row and every PO row so the columns line up.
export const GRID_COLUMNS = 'grid-cols-[32px_minmax(130px,1fr)_120px_minmax(150px,1.2fr)_130px_80px_minmax(160px,1.2fr)]';
// The columns above, for aria-colspan on a row that spans them all.
export const COLUMN_COUNT = 7;

// Shipment rows in an expanded PO: ship date | pcs · lines | state | details | note | actions.
export const SHIPMENT_GRID = 'grid-cols-[120px_120px_80px_minmax(180px,1.4fr)_minmax(120px,1fr)_170px]';
// The fixed and minimum column widths above plus five 12px gaps.
export const SHIPMENT_GRID_MIN_WIDTH = 850;
export const SHIPMENT_COLUMN_COUNT = 6;
